var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#00a14b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.5C9.33579 8.5 9 8.83579 9 9.25C9 9.66421 9.33579 10 9.75 10H18.25C18.6642 10 19 9.66421 19 9.25C19 8.83579 18.6642 8.5 18.25 8.5H9.75ZM14.5303 11.2197C14.2374 10.9268 13.7626 10.9268 13.4697 11.2197L10.2197 14.4697C9.92678 14.7626 9.92678 15.2374 10.2197 15.5303C10.5126 15.8232 10.9874 15.8232 11.2803 15.5303L13.25 13.5607V19.75C13.25 20.1642 13.5858 20.5 14 20.5C14.4142 20.5 14.75 20.1642 14.75 19.75V13.5607L16.7197 15.5303C17.0126 15.8232 17.4874 15.8232 17.7803 15.5303C18.0732 15.2374 18.0732 14.7626 17.7803 14.4697L14.5303 11.2197Z",
    fill: "#00a14b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.41bebb9e3a6865fbbbf0629f75d2a88c.svg";
export { ForwardRef as ReactComponent };